import * as types from '../../lib/actionTypes.es6';

export const initialState = {
  partnerConfig: null,
  partnerConfigErrors: null,
  partnerConfigLoader: false,

  partnerConfigEmail: null,
  partnerConfigEmailErrors: null,
  partnerConfigEmailLoader: false,

  partnerConfigEmailClients: null,
  partnerConfigEmailClientsErrors: null,
  partnerConfigEmailClientsLoader: false,

  partnerConfigClaim: null,
  partnerConfigClaimErrors: null,
  partnerConfigClaimLoader: false,

  partnerConfigGroup: null,
  partnerConfigGroupErrors: null,
  partnerConfigGroupLoader: false,

  updatePartner: null,
  updatePartnerSuccess: false,
  updatePartnerLoader: false,
  updatePartnerError: null,

  updatePartnerConfig: null,
  updatePartnerConfigSuccess: false,
  updatePartnerConfigLoader: false,
  updatePartnerConfigError: null,

  updatePartnerConfigEmail: null,
  updatePartnerConfigEmailSuccess: false,
  updatePartnerConfigEmailLoader: false,
  updatePartnerConfigEmailError: null,

  updatePartnerConfigClaim: null,
  updatePartnerConfigClaimSuccess: false,
  updatePartnerConfigClaimLoader: false,
  updatePartnerConfigClaimError: null,

  updatePartnerConfigGroup: null,
  updatePartnerConfigGroupSuccess: false,
  updatePartnerConfigGroupLoader: false,
  updatePartnerConfigGroupError: null,

  smsChannels: [],
  smsChannelResolution: null,
  smsChannelsLoader: false,
  smsChannelsError: null,

  saveSmsChannelLoader: false,
  saveSmsChannelSuccess: false,
  saveSmsChannelError: null,

  deleteSmsChannelLoader: false,
  deleteSmsChannelSuccess: false,
  deleteSmsChannelError: null,

  testSmsChannelLoader: false,
  testSmsChannelResult: null,
  testSmsChannelError: null,

  saveChannelResolutionLoader: false,
  saveChannelResolutionSuccess: false,
  saveChannelResolutionError: null,

  policyMakerChecks: [],
  policyMakerChecksLoader: false,
  policyMakerChecksError: null,
  // Separates "not fetched yet" from "this partner has none" — the approval
  // dashboards and their menu entries fall back to a built-in stage list
  // until the real one is known.
  policyMakerChecksLoaded: false,

  savePolicyMakerCheckLoader: false,
  savePolicyMakerCheckSuccess: false,
  savePolicyMakerCheckError: null,

  deletePolicyMakerCheckLoader: false,
  deletePolicyMakerCheckSuccess: false,
  deletePolicyMakerCheckError: null,
};

export default function partnerStatusReducer(state = initialState, action) {
  switch (action.type) {

    // partner configs
    case types.GET_PARTNER_CONFIGS_REQUEST:
      return { ...state, partnerConfig: null, partnerConfigErrors: null, partnerConfigLoader: true };

    case types.GET_PARTNER_CONFIGS_SUCCESS:
      return { ...state, partnerConfig: action.payload, partnerConfigErrors: null, partnerConfigLoader: false };

    case types.GET_PARTNER_CONFIGS_FAILURE:
      return { ...state, partnerConfig: null, partnerConfigErrors: action.payload, partnerConfigLoader: false };


    // partner email configs
    case types.GET_PARTNER_EMAIL_CONFIGS_REQUEST:
      return { ...state, partnerConfigEmail: null, partnerConfigEmailErrors: null, partnerConfigEmailLoader: true };

    case types.GET_PARTNER_EMAIL_CONFIGS_SUCCESS:
      return { ...state, partnerConfigEmail: action.payload, partnerConfigEmailErrors: null, partnerConfigEmailLoader: false };

    case types.GET_PARTNER_EMAIL_CONFIGS_FAILURE:
      return { ...state, partnerConfigEmail: null, partnerConfigEmailErrors: action.payload, partnerConfigEmailLoader: false };


    // email clients
    case types.GET_EMAIL_CLIENTS_REQUEST:
      return { ...state, partnerConfigEmailClientsLoader: true, partnerConfigEmailClientsErrors: null };

    case types.GET_EMAIL_CLIENTS_SUCCESS:
      return { ...state, partnerConfigEmailClients: action.payload, partnerConfigEmailClientsLoader: false };

    case types.GET_EMAIL_CLIENTS_FAILED:
      return { ...state, partnerConfigEmailClientsLoader: false, partnerConfigEmailClientsErrors: action.payload };


    // partner config claim
    case types.GET_PARTNER_CONFIGS_CLAIM_REQUEST:
      return { ...state, partnerConfigClaim: null, partnerConfigClaimErrors: null, partnerConfigClaimLoader: true };

    case types.GET_PARTNER_CONFIGS_CLAIM_SUCCESS:
      return { ...state, partnerConfigClaim: action.payload, partnerConfigClaimErrors: null, partnerConfigClaimLoader: false };

    case types.GET_PARTNER_CONFIGS_CLAIM_FAILURE:
      return { ...state, partnerConfigClaim: null, partnerConfigClaimErrors: action.payload, partnerConfigClaimLoader: false };


    // partner config group
    case types.GET_PARTNER_CONFIGS_GROUP_REQUEST:
      return { ...state, partnerConfigGroup: null, partnerConfigGroupErrors: null, partnerConfigGroupLoader: true };

    case types.GET_PARTNER_CONFIGS_GROUP_SUCCESS:
      return { ...state, partnerConfigGroup: action.payload, partnerConfigGroupErrors: null, partnerConfigGroupLoader: false };

    case types.GET_PARTNER_CONFIGS_GROUP_FAILURE:
      return { ...state, partnerConfigGroup: null, partnerConfigGroupErrors: action.payload, partnerConfigGroupLoader: false };


    // update partner config
    case types.UPDATE_PARTNER_REQUEST:
      return { ...state, updatePartnerError: null, updatePartnerLoader: true, updatePartnerSuccess: false, updatePartner: null };

    case types.UPDATE_PARTNER_SUCCESS:
      return { ...state, updatePartner: action.payload, updatePartnerSuccess: true, updatePartnerLoader: false, updatePartnerError: null };

    case types.UPDATE_PARTNER_FAILURE:
      return { ...state, updatePartnerLoader: false, updatePartnerError: action.payload };

    case types.RESET_UPDATE_PARTNER_SUCCESS:
      return { ...state, updatePartnerSuccess: false };

    case types.RESET_UPDATE_PARTNER_ERROR:
      return { ...state, updatePartnerError: null };


    // update partner config
    case types.UPDATE_PARTNER_CONFIG_REQUEST:
      return { ...state, updatePartnerConfigError: null, updatePartnerConfigLoader: true, updatePartnerConfigSuccess: false, updatePartnerConfig: null };

    case types.UPDATE_PARTNER_CONFIG_SUCCESS:
      return { ...state, updatePartnerConfig: action.payload, updatePartnerConfigSuccess: true, updatePartnerConfigLoader: false, updatePartnerConfigError: null };

    case types.UPDATE_PARTNER_CONFIG_FAILURE:
      return { ...state, updatePartnerConfigLoader: false, updatePartnerConfigError: action.payload };

    case types.RESET_UPDATE_PARTNER_CONFIG_SUCCESS:
      return { ...state, updatePartnerConfigSuccess: false };

    case types.RESET_UPDATE_PARTNER_CONFIG_ERROR:
      return { ...state, updatePartnerConfigError: null };

    // update partner config email 
    case types.UPDATE_PARTNER_CONFIG_EMAIL_REQUEST:
      return { ...state, updatePartnerConfigEmailError: null, updatePartnerConfigEmailLoader: true, updatePartnerConfigEmailSuccess: false, updatePartnerConfigEmail: null };

    case types.UPDATE_PARTNER_CONFIG_EMAIL_SUCCESS:
      return { ...state, updatePartnerConfigEmail: action.payload, updatePartnerConfigEmailSuccess: true, updatePartnerConfigEmailLoader: false, updatePartnerConfigEmailError: null };

    case types.UPDATE_PARTNER_CONFIG_EMAIL_FAILURE:
      return { ...state, updatePartnerConfigEmailLoader: false, updatePartnerConfigEmailError: action.payload };

    case types.RESET_UPDATE_PARTNER_CONFIG_EMAIL_SUCCESS:
      return { ...state, updatePartnerConfigEmailSuccess: false };

    case types.RESET_UPDATE_PARTNER_CONFIG_EMAIL_ERROR:
      return { ...state, updatePartnerConfigEmailError: null };


    // update partner config claim 
    case types.UPDATE_PARTNER_CONFIG_CLAIM_REQUEST:
      return { ...state, updatePartnerConfigClaimError: null, updatePartnerConfigClaimLoader: true, updatePartnerConfigClaimSuccess: false, updatePartnerConfigClaim: null };

    case types.UPDATE_PARTNER_CONFIG_CLAIM_SUCCESS:
      return { ...state, updatePartnerConfigClaim: action.payload, updatePartnerConfigClaimSuccess: true, updatePartnerConfigClaimLoader: false, updatePartnerConfigClaimError: null };

    case types.UPDATE_PARTNER_CONFIG_CLAIM_FAILURE:
      return { ...state, updatePartnerConfigClaimLoader: false, updatePartnerConfigClaimError: action.payload };

    case types.RESET_UPDATE_PARTNER_CONFIG_CLAIM_SUCCESS:
      return { ...state, updatePartnerConfigClaimSuccess: false };

    case types.RESET_UPDATE_PARTNER_CONFIG_CLAIM_ERROR:
      return { ...state, updatePartnerConfigClaimError: null };

    // update partner config group 
    case types.UPDATE_PARTNER_CONFIG_GROUP_REQUEST:
      return { ...state, updatePartnerConfigGroupError: null, updatePartnerConfigGroupLoader: true, updatePartnerConfigGroupSuccess: false, updatePartnerConfigGroup: null };

    case types.UPDATE_PARTNER_CONFIG_GROUP_SUCCESS:
      return { ...state, updatePartnerConfigGroup: action.payload, updatePartnerConfigGroupSuccess: true, updatePartnerConfigGroupLoader: false, updatePartnerConfigGroupError: null };

    case types.UPDATE_PARTNER_CONFIG_GROUP_FAILURE:
      return { ...state, updatePartnerConfigGroupLoader: false, updatePartnerConfigGroupError: action.payload };

    case types.RESET_UPDATE_PARTNER_CONFIG_GROUP_SUCCESS:
      return { ...state, updatePartnerConfigGroupSuccess: false };

    case types.RESET_UPDATE_PARTNER_CONFIG_GROUP_ERROR:
      return { ...state, updatePartnerConfigGroupError: null };

    // SMS channels
    case types.GET_PARTNER_SMS_CHANNELS_REQUEST:
      return {
        ...state,
        smsChannels: [],
        smsChannelResolution: null,
        smsChannelsLoader: true,
        smsChannelsError: null,
      };
    case types.GET_PARTNER_SMS_CHANNELS_SUCCESS:
      return {
        ...state,
        smsChannels: (action.payload && action.payload.sms_channels) || [],
        smsChannelResolution: (action.payload && action.payload.channel_resolution) || null,
        smsChannelsLoader: false,
        smsChannelsError: null,
      };
    case types.GET_PARTNER_SMS_CHANNELS_FAILURE:
      return {
        ...state,
        smsChannelsLoader: false,
        smsChannelsError: action.payload,
      };

    case types.SAVE_SMS_CHANNEL_REQUEST:
      return {
        ...state,
        saveSmsChannelLoader: true,
        saveSmsChannelSuccess: false,
        saveSmsChannelError: null,
      };
    case types.SAVE_SMS_CHANNEL_SUCCESS:
      return {
        ...state,
        saveSmsChannelLoader: false,
        saveSmsChannelSuccess: true,
        saveSmsChannelError: null,
      };
    case types.SAVE_SMS_CHANNEL_FAILURE:
      return {
        ...state,
        saveSmsChannelLoader: false,
        saveSmsChannelError: action.payload,
      };
    case types.RESET_SAVE_SMS_CHANNEL_SUCCESS:
      return { ...state, saveSmsChannelSuccess: false };
    case types.RESET_SAVE_SMS_CHANNEL_ERROR:
      return { ...state, saveSmsChannelError: null };

    case types.DELETE_SMS_CHANNEL_REQUEST:
      return {
        ...state,
        deleteSmsChannelLoader: true,
        deleteSmsChannelSuccess: false,
        deleteSmsChannelError: null,
      };
    case types.DELETE_SMS_CHANNEL_SUCCESS:
      return {
        ...state,
        deleteSmsChannelLoader: false,
        deleteSmsChannelSuccess: true,
        deleteSmsChannelError: null,
      };
    case types.DELETE_SMS_CHANNEL_FAILURE:
      return {
        ...state,
        deleteSmsChannelLoader: false,
        deleteSmsChannelError: action.payload,
      };
    case types.RESET_DELETE_SMS_CHANNEL_SUCCESS:
      return { ...state, deleteSmsChannelSuccess: false };
    case types.RESET_DELETE_SMS_CHANNEL_ERROR:
      return { ...state, deleteSmsChannelError: null };

    case types.TEST_SMS_CHANNEL_REQUEST:
      return {
        ...state,
        testSmsChannelLoader: true,
        testSmsChannelResult: null,
        testSmsChannelError: null,
      };
    case types.TEST_SMS_CHANNEL_SUCCESS:
      return {
        ...state,
        testSmsChannelLoader: false,
        testSmsChannelResult: action.payload,
        testSmsChannelError: null,
      };
    case types.TEST_SMS_CHANNEL_FAILURE:
      return {
        ...state,
        testSmsChannelLoader: false,
        testSmsChannelError: action.payload,
      };
    case types.RESET_TEST_SMS_CHANNEL:
      return {
        ...state,
        testSmsChannelLoader: false,
        testSmsChannelResult: null,
        testSmsChannelError: null,
      };

    case types.SAVE_CHANNEL_RESOLUTION_REQUEST:
      return {
        ...state,
        saveChannelResolutionLoader: true,
        saveChannelResolutionSuccess: false,
        saveChannelResolutionError: null,
      };
    case types.SAVE_CHANNEL_RESOLUTION_SUCCESS:
      return {
        ...state,
        saveChannelResolutionLoader: false,
        saveChannelResolutionSuccess: true,
        saveChannelResolutionError: null,
      };
    case types.SAVE_CHANNEL_RESOLUTION_FAILURE:
      return {
        ...state,
        saveChannelResolutionLoader: false,
        saveChannelResolutionError: action.payload,
      };
    case types.RESET_SAVE_CHANNEL_RESOLUTION_SUCCESS:
      return { ...state, saveChannelResolutionSuccess: false };
    case types.RESET_SAVE_CHANNEL_RESOLUTION_ERROR:
      return { ...state, saveChannelResolutionError: null };

    // Policy Maker Checks
    // The previous list is kept while refetching: it drives the approval-stage
    // menu, which would otherwise blink out on every reload.
    case types.GET_POLICY_MAKER_CHECKS_REQUEST:
      return {
        ...state,
        policyMakerChecksLoader: true,
        policyMakerChecksError: null,
      };
    case types.GET_POLICY_MAKER_CHECKS_SUCCESS:
      return {
        ...state,
        policyMakerChecks: action.payload || [],
        policyMakerChecksLoader: false,
        policyMakerChecksLoaded: true,
        policyMakerChecksError: null,
      };
    case types.GET_POLICY_MAKER_CHECKS_FAILURE:
      return {
        ...state,
        policyMakerChecksLoader: false,
        policyMakerChecksError: action.payload,
      };

    case types.SAVE_POLICY_MAKER_CHECK_REQUEST:
      return {
        ...state,
        savePolicyMakerCheckLoader: true,
        savePolicyMakerCheckSuccess: false,
        savePolicyMakerCheckError: null,
      };
    case types.SAVE_POLICY_MAKER_CHECK_SUCCESS:
      return {
        ...state,
        savePolicyMakerCheckLoader: false,
        savePolicyMakerCheckSuccess: true,
        savePolicyMakerCheckError: null,
      };
    case types.SAVE_POLICY_MAKER_CHECK_FAILURE:
      return {
        ...state,
        savePolicyMakerCheckLoader: false,
        savePolicyMakerCheckError: action.payload,
      };
    case types.RESET_SAVE_POLICY_MAKER_CHECK_SUCCESS:
      return { ...state, savePolicyMakerCheckSuccess: false };
    case types.RESET_SAVE_POLICY_MAKER_CHECK_ERROR:
      return { ...state, savePolicyMakerCheckError: null };

    case types.DELETE_POLICY_MAKER_CHECK_REQUEST:
      return {
        ...state,
        deletePolicyMakerCheckLoader: true,
        deletePolicyMakerCheckSuccess: false,
        deletePolicyMakerCheckError: null,
      };
    case types.DELETE_POLICY_MAKER_CHECK_SUCCESS:
      return {
        ...state,
        deletePolicyMakerCheckLoader: false,
        deletePolicyMakerCheckSuccess: true,
        deletePolicyMakerCheckError: null,
      };
    case types.DELETE_POLICY_MAKER_CHECK_FAILURE:
      return {
        ...state,
        deletePolicyMakerCheckLoader: false,
        deletePolicyMakerCheckError: action.payload,
      };
    case types.RESET_DELETE_POLICY_MAKER_CHECK_SUCCESS:
      return { ...state, deletePolicyMakerCheckSuccess: false };
    case types.RESET_DELETE_POLICY_MAKER_CHECK_ERROR:
      return { ...state, deletePolicyMakerCheckError: null };

    default:
      return state;
  }
}